export const REQUEST_EDITCLIENTADMINDATA = 'REQUEST_EDITCLIENTADMINDATA';
export const EDITCLIENTADMINDATA_RECEIVED = 'EDITCLIENTADMINDATA_RECEIVED';
export const CLEAR_EDITCLIENTADMINDATA  = 'CLEAR_EDITCLIENTADMINDATA'

